import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Header from './Header';

const Wrapper = styled.div`
  width: 100%;
`;

const Perm = ({ onRemove, summary, copy }) => (
  <Wrapper>
    <Header name={copy.perm} onRemove={onRemove} summary={summary} />
  </Wrapper>
);

Perm.defaultProps = {
  summary: false,
  onRemove: () => {},
};

Perm.propTypes = {
  onRemove: PropTypes.func,
  summary: PropTypes.bool,
  copy: PropTypes.shape({}).isRequired,
};

export default Perm;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/Treatments/Perm.js